import React from "react";
import { PublicCareerSettings } from "../../types";

interface CareerFooterProps {
  settings: PublicCareerSettings | null;
}

const CareerFooter: React.FC<CareerFooterProps> = ({ settings }) => {
  return (
    <div style={{
      background: "#fff", borderTop: "1px solid #e8eaed",
      padding: "20px 40px",
      display: "flex", justifyContent: "space-between", alignItems: "center",
      flexWrap: "wrap", gap: 8,
      marginTop: "auto"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {settings?.company_logo_url && (
          <img src={settings.company_logo_url} alt="" style={{ height: 24, objectFit: "contain" }} />
        )}
        <span style={{ fontSize: 13, color: "#888" }}>
          © {new Date().getFullYear()} {settings?.company_name}
        </span>
      </div>
      <span style={{ fontSize: 12, color: "#bbb" }}>Powered by Zyvo</span>
    </div>
  );
};

export default CareerFooter;
